export default axios => ({
  getEnv: () => axios.get('env')
})
